import Shape from './Shape';
import Coords from '../Util/Coords';

export default class Ellipse extends Shape {

    constructor(p1, p2) {
        super();
        this.point1 = p1;
        this.point2 = p2;
        this.center = [0, 0];
        this.radius = [0, 0];
    }

    isShape() {
        return true;
    }

    export() {
        return {
            id: this.id,
            type: 'ellipse',
            layer: this.layer,
            point1: this.point1,
            point2: this.point2,
            props: this.props.export('ellipse'),
        }
    }

    updateProp(key, value) {
        if (key === 'point1') {
            this.point1 = value;
        } else if (key === 'point2') {
            this.point2 = value;
        }

        this.center = [(this.point2[0]+this.point1[0])/2, (this.point2[1]+this.point1[1])/2];
        this.radius = [Math.abs(this.center[0]-this.point1[0]), Math.abs(this.center[1]-this.point1[1])];
    }

    load (props) {
        super.load(props);
        this.center = [(this.point2[0]+this.point1[0])/2, (this.point2[1]+this.point1[1])/2];
        this.radius = [Math.abs(this.center[0]-this.point1[0]), Math.abs(this.center[1]-this.point1[1])];
    }

    isHover (point) {
        let a = point[0] - this.center[0];
        let b = point[1] - this.center[1];
        let rx = this.radius[0] * this.radius[0];
        let ry = this.radius[1] * this.radius[1];

        if (((a*a/rx) + (b*b/ry)) <= 1) {
            return this.id;
        }

        return false;
    }

    isUnderSelection(bounds) {
        return Coords.inRect(this.point1, bounds) && Coords.inRect(this.point2, bounds);
    }

    isHoverPoint(p, props) {
        let p1 = Coords.toView(this.point1, props.viewCenter, props.lookingAt, props.tileSize);
        let p2 = Coords.toView(this.point2, props.viewCenter, props.lookingAt, props.tileSize);

        let p1a = p[0] - p1[0];
        let p1b = p[1] - p1[1];
        let p2a = p[0] - p2[0];
        let p2b = p[1] - p2[1];

        if (Math.sqrt(p1a*p1a + p1b*p1b) < 12) {
            return 'point1';
        }

        if (Math.sqrt(p2a*p2a + p2b*p2b) < 12) {
            return 'point2';
        }

        return false;
    }

    getMoveableProps() {
        return [this.point1, this.point2];
    }

    relativeMove(point, origin, initialState) {
        let dx = point[0] - origin[0];
        let dy = point[1] - origin[1];

        this.updateProp('point1', [initialState[0][0] + dx, initialState[0][1] + dy]);
        this.updateProp('point2', [initialState[1][0] + dx, initialState[1][1] + dy]);
    }

    draw(props) {
        let center = Coords.toView(this.center, props.viewCenter, props.lookingAt, props.tileSize);
        let radius = [this.radius[0]*props.tileSize, this.radius[1]*props.tileSize];


        if (!props.hover) {
            this.ctx.strokeStyle = '#1e1e1e';
            this.ctx.lineWidth = 3;
        } else {
            this.ctx.strokeStyle = '#0ff';
            this.ctx.lineWidth = 6;
        }
        this.ctx.fillStyle = this.props.color;

        this.ctx.beginPath();
        this.ctx.ellipse(center[0], center[1], radius[0], radius[1], 0, 0, 6.283185307179586);
        this.ctx.stroke();
        this.ctx.fill();

        if (props.hover) {
            let p1 = Coords.toView(this.point1, props.viewCenter, props.lookingAt, props.tileSize);
            let p2 = Coords.toView(this.point2, props.viewCenter, props.lookingAt, props.tileSize);

            this.ctx.fillStyle = '#0ff';
            this.ctx.strokeStyle = '#0ff';
            this.ctx.lineWidth = 6;

            this.ctx.fillRect(p1[0]-5, p1[1]-5, 10, 10);
            this.ctx.strokeRect(p1[0]-5, p1[1]-5, 10, 10);

            this.ctx.fillRect(p2[0]-5, p2[1]-5, 10, 10);
            this.ctx.strokeRect(p2[0]-5, p2[1]-5, 10, 10);
        }
    }

}